<div id="wilcity-single-listing-content">
  <div class="wil-content">
    <div class="listing-detail_module__2-bfH">
      <header class="listing-detail_header__18Cfs">
        <div *ngIf="cover_img" class="listing-detail_img__3DyYX pos-a-full bg-cover"
          [ngStyle]="{ 'background-image': 'url(' + cover_img + ')' }"></div>
        <div *ngIf="listing_galleries.length > 0" class="wil-header-btn-wrapper" style="z-index: 1">
          <a (click)="openGalleryModal()" class="wil-btn wil-btn--overlay-dark wil-btn--sm wil-btn--round">
            <span class="list_icon__2YpTp"><i class="la la-photo"></i></span> <span class="">Tour this Listing</span>
          </a>
        </div>
      </header>

      <div class="listing-detail_first__1PClf">
        <div class="container">
          <div class="listing-detail_left__22FMI">
            <div class="listing-detail_goo__1A8J-">
              <div class="listing-detail_logo__3fI4O bg-cover" [ngStyle]="{ 'background-image': 'url(' + logo + ')' }">
                <a href="#"><img *ngIf="logo" [src]="logo" alt="{{ listing.title }}" class="hidden" /></a>
              </div>
            </div>
            <div class="listing-detail_titleWrap__2A2Mm js-titleWrap-detail">
              <h1 class="listing-detail_title__2cR-R flex">
                <span class="listing-detail_text__31u2P">
                  {{ listing.title }}
                </span>
                <span *ngIf="listing.claimer_id" class="listing-detail_claim__10fsw color-primary">
                  <img width="30" height="30" src="assets/img/listing-verified.webp" alt="Verified" title="Verified"
                    data-ll-status="loaded">
                </span>
              </h1>
              <span class="listing-detail_tagline__3u_9y">{{ listing.tagline }}</span>
            </div>
          </div>
          <div class="listing-detail_right__2KHL5">
            <div class="listing-detail_rightButton__30xaS clearfix">
              <div class="wil-lists-item">
                <div class="listing-detail_rightItem__2CjTS wilcity-single-tool-favorite">
                  <a (click)="onClickListingFavorite(listing.id)"
                    class="wil-btn wil-btn--border wil-btn--round wil-btn--sm">
                    <i [ngClass]="listing.is_favorite ? 'la-heart color-primary' : 'color-quaternary la-heart-o'"
                      class="la"></i>
                    <span class="">Favorite</span>
                  </a>
                </div>
                <div class="listing-detail_rightItem__2CjTS wilcity-single-tool-inbox">
                  <a (click)="sendMessage()" class="wil-btn wil-btn--border wil-btn--round wil-btn--sm">
                    <i class="la la-envelope color-1"></i> <span class="">Message</span>
                  </a>
                </div>
                <div class="listing-detail_rightItem__2CjTS wil-single-tool-share">
                  <a (click)="listing.show_share_options = !listing.show_share_options"
                    (clickOutside)="listing.show_share_options = false"
                    class="wil-btn wil-btn--border wil-btn--round wil-btn--sm">
                    <i class="color-primary la la-share"></i> <span class="">Share</span>
                  </a>
                  <div class="listing-detail_shareContent__2nr-2" [ngClass]="{ active: listing.show_share_options }">
                    <div class="
                        list_module__1eis9
                        list-none
                        list_social__31Q0V
                        list_medium__1aT2c
                        list_abs__OP7Og
                        arrow--top-right
                      ">
                      <share-buttons [theme]="'material-dark'"
                        [include]="['facebook', 'twitter', 'linkedin', 'pinterest', 'email']" [title]="listing.title"
                        [url]="router.url" [image]="cover_img" [autoSetMeta]="false"></share-buttons>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- navigation -->
      <div class="detail-navtop_module__zo_OS js-detail-navtop">
        <div class="container">
          <div *ngIf="listing.button_name && listing.button_link" class="detail-navtop_right__KPAlw">
            <a rel="nofollow" target="_blank" href="{{ listing.button_link }}"
              class="wil-btn wil-btn--primary2 wil-btn--round wil-btn--md wil-btn--block">
              <i *ngIf="listing.button_icon" class="la la-{{ listing.button_icon }}"></i>
              {{ listing.button_name }}
            </a>
          </div>
          <nav class="detail-navtop_nav__1j1Ti" style="min-height: 73px">
            <ul class="list_module__1eis9 list-none list_horizontal__7fIr5">
              <li class="list_item__3YghP">
                <a (click)="onChangeTab('home')" class="list_link__2rDA1 text-ellipsis color-primary--hover"
                  [ngClass]="{ 'color-primary': current_tab === 'home' }"
                  btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                  <span class="list_icon__2YpTp"><i class="la la-home"></i></span>
                  <span class="list_text__35R07">Home</span>
                </a>
              </li>
              <li class="list_item__3YghP wil-single-navcontent">
                <a (click)="onChangeTab('description')" class="list_link__2rDA1 text-ellipsis color-primary--hover"
                  [ngClass]="{ 'color-primary': current_tab === 'description' }"
                  btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                  <span class="list_icon__2YpTp"><i class="la la-file-text"></i></span>
                  <span class="list_text__35R07">Description</span>
                </a>
              </li>
              <li class="list_item__3YghP wil-single-navphotos">
                <a (click)="onChangeTab('photos')" class="list_link__2rDA1 text-ellipsis color-primary--hover"
                  [ngClass]="{ 'color-primary': current_tab === 'photos' }"
                  btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                  <span class="list_icon__2YpTp"><i class="la la-image"></i></span>
                  <span class="list_text__35R07">Photos</span>
                </a>
              </li>
              <li class="list_item__3YghP wil-single-navvideos">
                <a (click)="onChangeTab('videos')" class="list_link__2rDA1 text-ellipsis color-primary--hover"
                  [ngClass]="{ 'color-primary': current_tab === 'videos' }"
                  btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                  <span class="list_icon__2YpTp"><i class="la la-video-camera"></i></span>
                  <span class="list_text__35R07">Videos</span>
                </a>
              </li>
              <li class="list_item__3YghP wil-single-navreviews">
                <a (click)="onChangeTab('reviews')" class="list_link__2rDA1 text-ellipsis color-primary--hover"
                  [ngClass]="{ 'color-primary': current_tab === 'reviews' }"
                  btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                  <span class="list_icon__2YpTp"><i class="la la-star-o"></i></span>
                  <span class="list_text__35R07">Reviews</span>
                </a>
              </li>
              <li class="list_item__3YghP wil-single-navmy_products">
                <a (click)="onChangeTab('products')" class="list_link__2rDA1 text-ellipsis color-primary--hover"
                  btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                  <span class="list_icon__2YpTp"><i class="la la-shopping-cart"></i></span>
                  <span class="list_text__35R07">My Shop</span>
                </a>
              </li>
              <!-- <li class="list_item__3YghP wil-single-navlisting_tag"><a
                                    href="https://www.blackdirectory.co.uk/listing/auto-for-trade-2/?tab=listing_tag"
                                    target="_self" class="list_link__2rDA1 text-ellipsis color-primary--hover"
                                     btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                                    <span class="list_icon__2YpTp"><i class="la la-list-alt"></i></span> <span
                                        class="list_text__35R07">Listing Features</span>
                                </a>
                            </li> -->
              <!-- <li class="list_item__3YghP wil-single-nav-listing-settings"><a
                                    href="https://www.blackdirectory.co.uk/listing/auto-for-trade-2/?tab=listing-settings"
                                    target="_self" class="list_link__2rDA1 text-ellipsis color-primary--hover"
                                     btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                                    <span class="list_icon__2YpTp"><i class="la la-cog"></i></span> <span
                                        class="list_text__35R07">Listing Settings</span>
                                </a>
                            </li> -->
            </ul>
          </nav>
        </div>
      </div>

      <div id="wil-home-section-wrapper" class="listing-detail_body__287ZB">
        <div class="container">
          <!-- current tab = home -->
          <div *ngIf="current_tab == 'home'" id="single-home" data-tab-key="home"
            class="single-tab-content wilcity-js-toggle-group">
            <div class="listing-detail_row__2UU6R clearfix">
              <div class="wil-colLarge wil-sidebarRight">
                <!-- listing average review -->
                <div *ngIf="listing.no_of_rating > 0"
                  class="wilcity-single-listing-average-review-box content-box_module__333d9">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h4 class="content-box_title__1gBHS">
                        <i class="la la-star-o"></i>
                        <span>Average Reviews</span>
                      </h4>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB">
                    <div class="average-rating-info_module__TOHeu">
                      <div class="average-rating-info_left__255Tl">
                        <div class="rated-small_module__1vw2B">
                          <div [attr.data-rated]="listing.avg_rating" class="rated-small_wrap__2Eetz">
                            <div class="rated-small_overallRating__oFmKR">{{ listing.avg_rating }}</div>
                            <div class="rated-small_ratingWrap__3lzhB">
                              <div class="rated-small_maxRating__2D9mI">10</div>
                              <div class="rated-small_ratingOverview__2kCI_">
                                {{ fnReviewComment(listing.avg_rating) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="average-rating-info_right__3xLnz">
                        <div class="average-rating-info_item__2yvNR">
                          <div class="average-rating-info_item__2yvNR_item">
                            <span class="average-rating-info_text__3Cq-a">How Would You Rate This Business?</span>
                            <div class="rated-small_module__1vw2B rated-small_style-4__VTQSw">
                              <div [attr.data-rated]="listing.avg_rating" class="rated-small_wrap__2Eetz">
                                <div class="rated-small_overallRating__oFmKR">{{ listing.avg_rating }}/10</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <footer class="content-box_footer__kswf3"><a (click)="openReviewModal()"
                                            class="content-box_link__2K0Ib wil-text-center"> <i
                                                class="la la-star-o"></i> <span class="">Add a
                                                review</span>
                                        </a></footer> -->
                </div>

                <!-- listing description -->
                <div class="content-box_module__333d9 wilcity-single-listing-content-box">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h2 class="content-box_title__1gBHS">
                        <i class="la la-file-text"></i>
                        <span>Description</span>
                      </h2>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB">
                    <div [innerHTML]="listing.description">

                    </div>
                  </div>
                </div>

                <!-- listing photos -->
                <div *ngIf="listing_galleries.length > 0" class="content-box_module__333d9">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h2 class="content-box_title__1gBHS">
                        <i class="la la-image"></i>
                        <span>Photos</span>
                      </h2>
                    </div>
                  </header>
                  <div>
                    <div class="content-box_body__3tSRB">
                      <div data-col-xs-gap="5" data-col-sm-gap="10" class="row">
                        <div *ngFor="let item of listing_galleries; let index = index" class="col-xs-6 col-sm-3">
                          <div class="gallery-item_module__1wn6T">
                            <div class="imageCover_module__1VM4k">
                              <div class="imageCover_img__3pxw7" (click)="openGalleryModal(index)"
                                [ngStyle]="{ 'background-image': 'url(' + item.medium + ')' }">
                                <img [src]="item.medium" class="cursor-pointer" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <footer class="content-box_footer__kswf3">
                    <a (click)="onChangeTab('photos')"
                      class="list_link__2rDA1 text-ellipsis color-primary--hover wil-text-center"
                      btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                      <span class="">See All</span>
                    </a>
                  </footer>
                </div>

                <!-- listing videos -->
                <div *ngIf="listing_videos.length > 0" class="content-box_module__333d9">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h2 class="content-box_title__1gBHS">
                        <i class="la la-video-camera"></i>
                        <span>Videos</span>
                      </h2>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB">
                    <div class="gallery_module__2AbLA">
                      <div>
                        <div data-col-xs-gap="5" data-col-sm-gap="10" class="row">
                          <div *ngFor="let item of listing_videos; let index = index" class="col-xs-12 col-sm-4">
                            <div class="gallery-item_module__1wn6T">
                              <div class="video-popup_module__2P6ZG video-popup_sm__11-9c">
                                <div class="video-popup_media__dEwwq">
                                  <div class="video-popup_img__3zV5d bg-cover"
                                    [ngStyle]="{ 'background-image': 'url(' + item.image + ')' }"></div>
                                  <a (click)="openVideoModal(index)" class="video-popup_popup__17b-F js-video-popup"><i
                                      class="la la-play"></i></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <footer class="content-box_footer__kswf3">
                    <a (click)="onChangeTab('videos')"
                      class="list_link__2rDA1 text-ellipsis color-primary--hover wil-text-center"
                      btn-classes="list_link__2rDA1 text-ellipsis color-primary--hover">
                      <span class="">See All</span>
                    </a>
                  </footer>
                </div>

                <!-- listing menus -->
                <div *ngIf="listing_menus.length > 0" id="single-home-restaurant-menu-section"
                  class="single-tab-content">
                  <div class="content-box_module__333d9 pos-r">
                    <header class="content-box_header__xPnGx clearfix">
                      <div class="wil-float-left">
                        <h4 class="content-box_title__1gBHS">
                          <i class="la la-cutlery"></i>
                          <span>Restaurant Menu</span>
                        </h4>
                      </div>
                    </header>
                    <div class="content-box_body__3tSRB">
                      <div data-col-xs-gap="10" class="row wil-flex-wrap">
                        <div *ngFor="let menu of listing_menus; let index = index" class="col-md-12 col-xs-12">
                          <div class="">
                            <div class="mb-20 pt-10 wil-text-center">
                              <h5 class="mt-0 mb-0">{{ menu.title }}</h5>
                              <p class="fs-13">{{ menu.description }}</p>
                              <i class="fs-32 color-primary la la-{{ menu.icon }}"></i>
                            </div>
                            <ul *ngIf="menu.items.length > 0" class="list-none mb-20">
                              <li *ngFor="let item of menu.items" class="no-style">
                                <div class="utility-box-1_module__MYXpX utility-box-1_menus__17rbu">
                                  <div *ngIf="item.image" class="utility-box-1_avatar__DB9c_ rounded-circle show-image">
                                    <img [src]="item.image | imageSrc: 'listing':'thumb'"
                                      class="display-block cursor-pointer" />
                                  </div>
                                  <a *ngIf="item.link;else noItemLink" href="{{ item.link }}"
                                    target="{{ item.open_new_window == 'yes' ? '_blank' : '_self' }}" class="no-style"
                                    rel="nofollow">
                                    <ng-container *ngTemplateOutlet="innerMenuItem"></ng-container>
                                  </a>
                                  <ng-template #noItemLink>
                                    <ng-container *ngTemplateOutlet="innerMenuItem"></ng-container>
                                  </ng-template>
                                  <ng-template #innerMenuItem>
                                    <div class="utility-box-1_body__8qd9j">
                                      <div class="utility-box-1_group__2ZPA2">
                                        <h3 class="utility-box-1_title__1I925">
                                          {{ item.title }}
                                        </h3>
                                        <div class="utility-box-1_content__3jEL7">
                                          {{ item.description }}
                                        </div>
                                      </div>
                                      <div class="utility-box-1_description__2VDJ6">£{{ item.price }}</div>
                                    </div>
                                  </ng-template>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- listing coupon -->
                <div *ngIf="listing_coupon.valid">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h2 class="content-box_title__1gBHS">
                        <i class="la la-tag"></i>
                        <span>Coupon</span>
                      </h2>
                    </div>
                  </header>
                  <div class="content-box_module__333d9">
                    <div class="content-box_body__3tSRB">
                      <div class="col-md-12">
                        <a (click)="openCouponModal()" class="wilcity-get-counpon">
                          <h4 class="color-quaternary mt-0 mb-0">{{ listing_coupon.title }}</h4>
                          <div>{{ listing_coupon.description }}</div>
                          <div>
                            <span>Expiry Date: </span> <span>{{ listing_coupon.expire }}</span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- listing review -->
                <div>
                  <div class="add-review_module__2KOQC">
                    <header class="add-review_wrap__K1JtF">
                      <div class="add-review_left__ziIv1">
                        <h3 class="add-review_title__3ePFu">
                          <span class="color-primary">{{ listing_reviews.length }} Review{{ listing_reviews.length |
                            pluralPipe: 's' }} For</span>
                          {{ listing.title }}
                        </h3>
                      </div>
                      <div *ngIf="currentUserCanReview" class="wil-float-right">
                        <a (click)="openReviewModal()" class="wil-btn wil-btn--primary wil-btn--sm wil-btn--round">
                          <i class="la la-star-o"></i> <span class="">Add a review</span>
                        </a>
                      </div>
                    </header>
                  </div>

                  <div *ngIf="listing_reviews.length > 0" data-v-0af02974="" id="wilcity-review-wrapper" class="pos-r">
                    <div data-v-0af02974="">
                      <div *ngFor="let item of listing_reviews; let index = index" class="comment-review_module__-Z5tr"
                        data-v-0af02974="">
                        <div class="comment-review_header__1si3M">
                          <div class="
                              utility-box-1_module__MYXpX
                              utility-box-1_boxLeft__3iS6b
                              clearfix
                              utility-box-1_sm__mopok
                              review-author-avatar
                            ">
                            <a class="utility-box-1_avatar__DB9c_ rounded-circle"
                              [ngStyle]="{ 'background-image': 'url(' + getReviewAvatar(item.profile_photo) + ')' }">
                              <img src="{{ item.profile_photo | imageSrc: 'users':'thumb' }}"
                                alt="{{ item.display_name != '' ? item.display_name : item.username }}" /></a>
                            <div class="utility-box-1_body__8qd9j">
                              <div class="utility-box-1_group__2ZPA2">
                                <h3 class="utility-box-1_title__1I925">
                                  <a>{{ item.display_name != '' ? item.display_name : item.username }}</a>
                                </h3>
                              </div>
                              <div class="utility-box-1_description__2VDJ6">
                                {{ item.created_at | date: 'longDate' }}
                              </div>
                            </div>
                          </div>
                          <div class="comment-review_abs__9mb1G pos-a-center-right">
                            <span class="comment-review_sticky__3iQ8y color-primary fs-20 v-middle visible-hidden"><i
                                class="la la-thumb-tack"></i></span>
                            <div class="rated-small_module__1vw2B">
                              <div [attr.data-rated]="item.rating" class="rated-small_wrap__2Eetz">
                                <div class="rated-small_overallRating__oFmKR">{{ item.rating }}</div>
                                <div class="rated-small_ratingWrap__3lzhB">
                                  <div class="rated-small_maxRating__2D9mI">10</div>
                                  <div class="rated-small_ratingOverview__2kCI_">{{ review_comment[item.rating] }}</div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="userCanEditReview(item.id)"
                              (clickOutside)="isReviewDotsClicked[item.id] = false"
                              class="dropdown_module__J_Zpj ml-20">
                              <div (click)="isReviewDotsClicked[item.id] = isReviewDotsClicked[item.id] ? false : true"
                                class="dropdown_threeDots__3fa2o">
                                <span class="dropdown_dot__3I1Rn"></span> <span class="dropdown_dot__3I1Rn"></span>
                                <span class="dropdown_dot__3I1Rn"></span>
                              </div>
                              <div [ngClass]="{ active: isReviewDotsClicked[item.id] }"
                                class="dropdown_itemsWrap__2fuze">
                                <ul data-v-52d0a98f="" class="
                                    list_module__1eis9
                                    list-none
                                    list_small__3fRoS
                                    list_abs__OP7Og
                                    arrow--top-right
                                  " has-wrap-for-icon="true">
                                  <li class="list_item__3YghP">
                                    <a data-v-52d0a98f="" (click)="openReviewModal(item)"
                                      class="list_link__2rDA1 text-ellipsis color-primary--hover"
                                      span-classes="list_text__35R07" review-id="17458">
                                      <span class="list_icon__2YpTp"><i class="la la-edit"></i></span>
                                      <span class="list_text__35R07">Edit review</span>
                                    </a>
                                  </li>
                                  <li class="list_item__3YghP">
                                    <a data-v-52d0a98f="" (click)="onDeleteReview(item.id)"
                                      class="list_link__2rDA1 text-ellipsis color-primary--hover"
                                      span-classes="list_text__35R07" review-id="17458">
                                      <span class="list_icon__2YpTp"><i class="la la-trash"></i></span>
                                      <span class="list_text__35R07">Delete</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="comment-review_body__qhUqq">
                          <div class="comment-review_content__1jFfZ">
                            <h3 class="comment-review_title__2WbAh">{{ item.title }}</h3>
                            <div class="wilcity-review-content wilcity-review-content-17458">
                              <div>
                                <p>{{ item.description }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="comment-review_meta__1chzm">
                            <span>{{ item.likes }} Like{{ item.likes | pluralPipe: 's' }}</span>
                            <span>{{ item.comments }} Comment{{ item.comments | pluralPipe: 's' }}</span>
                          </div>
                        </div>
                        <footer data-v-52d0a98f="" class="comment-review_footer__3XR0_">
                          <div data-v-52d0a98f="" class="comment-review_btnGroup__1PqPh">
                            <div data-v-52d0a98f="" class="comment-review_btn__32CMP">
                              <a (click)="onClickLikeReview(item.id, index)" class="utility-meta_module__mfOnV"
                                [ngClass]="{ 'color-primary': userHasLikedReview(item) }" btn-classes="'no-style'"
                                socials="facebook,twitter,linkedin,whatsapp">
                                <i class="la la-thumbs-up"></i>
                                <span class="">Like</span>
                              </a>
                            </div>
                            <!-- <div data-v-52d0a98f="" class="comment-review_btn__32CMP">
                                                            <div data-v-52d0a98f="" class="utility-meta_module__mfOnV"
                                                                icon="la la-share-square-o" btn-name="Share"><a href="#"
                                                                    target="_self" class="'no-style'"> <i
                                                                        class="color-primary la la-share"></i> <span
                                                                        class="">Share</span>
                                                                </a>
                                                            </div>
                                                        </div> -->
                          </div>
                          <div style="min-height: 100px" data-v-52d0a98f="">
                            <div>
                              <ul *ngIf="item.comment_list.length > 0"
                                class="comment-review_commentlist__1LH_D list-none">
                                <li *ngFor="let comment of item.comment_list"
                                  class="comment-review_commentlistItem__2DILM js-review-discussion-17459">
                                  <div data-v-7b959e52="" class="">
                                    <div class="
                                        utility-box-1_module__MYXpX
                                        utility-box-1_xs__3Nipt
                                        utility-box-1_boxLeft__3iS6b
                                        clearfix
                                      ">
                                      <a data-v-7b959e52="" [ngStyle]="{
                                          'background-image': 'url(' + getReviewAvatar(comment.profile_photo) + ')'
                                        }" class="utility-box-1_avatar__DB9c_ rounded-circle wil-float-left">
                                        <img src="{{ comment.profile_photo | imageSrc: 'users':'thumb' }}" alt="" /></a>
                                      <div data-v-7b959e52="" class="utility-box-1_body__8qd9j">
                                        <div data-v-7b959e52="" class="utility-box-1_group__2ZPA2">
                                          <h3 data-v-7b959e52="" class="utility-box-1_title__1I925">
                                            <a data-v-7b959e52="">{{
                                              comment.display_name != '' ? comment.display_name : comment.username
                                              }}</a>
                                          </h3>
                                          <div data-v-7b959e52="" class="utility-box-1_content__3jEL7">
                                            {{ comment.description }}
                                          </div>
                                        </div>
                                        <div data-v-7b959e52="" class="utility-box-1_description__2VDJ6"></div>
                                      </div>
                                      <div *ngIf="isCommentEditClicked[comment.id]"
                                        class="comment-review_comment__dJNqv mt-10">
                                        <div class="active field_module__1H6kT field_style4__2DBqx field-autoHeight">
                                          <div class="field_wrap__Gv92k">
                                            <textarea #commentField
                                              (keyup)="onKeydownCommentField($event, item.id, comment.id)"
                                              data-height-default="22"
                                              class="field_field__3U_Rt">{{ comment.description }}</textarea>
                                            <span class="field_label__2eCP7 text-ellipsis">Type a message...</span>
                                            <span class="bg-color-primary"></span>
                                            <div class="field_rightButton__1GGWz js-field-rightButton active">
                                              <span (click)="onSubmitComment(item.id, commentField.value, comment.id)"
                                                class="field_iconButton__2p3sr bg-color-primary"><i
                                                  class="la la-arrow-up"></i></span>
                                            </div>
                                            <div class="mt-10 pos-a review-cancel">
                                              <a (click)="onCloseCommentEdit(comment.id)" title="Cancel"><i
                                                  class="la la-times-circle"></i></a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div *ngIf="userCanEditComment(comment)"
                                      (clickOutside)="isCommentDotsClicked[comment.id] = false"
                                      class="dropdown_module__J_Zpj">
                                      <div (click)="
                                          isCommentDotsClicked[comment.id] = isCommentDotsClicked[comment.id]
                                            ? false
                                            : true
                                        " class="dropdown_threeDots__3fa2o">
                                        <span class="dropdown_dot__3I1Rn"></span>
                                        <span class="dropdown_dot__3I1Rn"></span>
                                        <span class="dropdown_dot__3I1Rn"></span>
                                      </div>
                                      <div [ngClass]="{ active: isCommentDotsClicked[comment.id] }"
                                        class="dropdown_itemsWrap__2fuze">
                                        <ul data-v-7b959e52="" class="
                                            list_module__1eis9
                                            list-none
                                            list_small__3fRoS
                                            list_abs__OP7Og
                                            arrow--top-right
                                          " has-wrap-for-icon="true">
                                          <li class="list_item__3YghP">
                                            <a (click)="onClickCommentEdit(comment.id)"
                                              class="list_link__2rDA1 text-ellipsis color-primary--hover">
                                              <span class="list_icon__2YpTp"><i class="la la-edit"></i></span>
                                              <span class="list_text__35R07">Edit</span>
                                            </a>
                                          </li>
                                          <li class="list_item__3YghP">
                                            <a (click)="onDeleteComment(comment.id)"
                                              class="list_link__2rDA1 text-ellipsis color-primary--hover">
                                              <span class="list_icon__2YpTp"><i class="la la-trash"></i></span>
                                              <span class="list_text__35R07">Delete</span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                              <div class="comment-review_form__20wWm">
                                <div class="
                                    utility-box-1_module__MYXpX
                                    utility-box-1_xs__3Nipt
                                    d-inline-block
                                    mr-10
                                    wil-float-left
                                  ">
                                  <a class="utility-box-1_avatar__DB9c_ rounded-circle"
                                    [ngStyle]="{ 'background-image': 'url(' + assetUrl + '/img/avatar-default.png)' }"><img
                                      src="{{ assetUrl + '/img/avatar-default.png' }}" alt="" /></a>
                                </div>
                                <div class="comment-review_comment__dJNqv">
                                  <div class="field_module__1H6kT field_style4__2DBqx field-autoHeight-2">
                                    <div class="field_wrap__Gv92k">
                                      <textarea #commentField (keyup)="onKeydownCommentField($event, item.id)"
                                        data-height-default="22" class="field_field__3U_Rt"></textarea>
                                      <span class="field_label__2eCP7 text-ellipsis">Type a message...</span>
                                      <span class="bg-color-primary"></span>
                                      <div class="field_rightButton__1GGWz js-field-rightButton">
                                        <span (click)="onSubmitComment(item.id, commentField.value)"
                                          class="field_iconButton__2p3sr bg-color-primary"><i
                                            class="la la-arrow-up"></i></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </footer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- listing sidebar -->
              <div data-tab-key="home" class="wil-colSmall wilcity-js-toggle-group">
                <!-- listing hours -->
                <div *ngIf="
                    listing.business_hour == 'open_for_selected_hours' ||
                    listing.business_hour == 'always_open' ||
                    listing.business_hour == 'business_closures'
                  " class="listing-hours_module__38Iy5">
                  <header data-toggle-button="hour" data-toggle-effect="slide" [ngClass]="{
                      open: isTodayOpen,
                      close: !isTodayOpen,
                      active: listing.business_hour == 'open_for_selected_hours'
                    }" class="listing-hours_header__1uH8N clearfix">
                    <div class="wil-float-left">
                      <h4 class="listing-hours_title__sRfK7">
                        <i class="la la-clock-o"></i>
                        <span>{{
                          listing.business_hour == 'open_for_selected_hours' ? 'Today' : 'BUSINESS HOURS'
                          }}</span>
                        <span *ngIf="listing.business_hour == 'open_for_selected_hours'"
                          [ngClass]="isTodayOpen ? 'open' : 'close'" class="listing-hours_status__dQ6Z9">{{ isTodayOpen
                          ? 'Open now' : 'Closed' }}</span>
                      </h4>
                    </div>
                    <!-- <div class="wil-float-right"><span class="listing-hours_todayhour__1iK4_"><span
                                                    class="listing-hours_todayhouritem__2WBlQ">08:00 -
                                                    17:00</span></span>
                                        </div> -->
                  </header>
                  <div *ngIf="listing.business_hour == 'business_closures'" class="content-box_body__3tSRB">
                    <h3 class="business-closures wil-btn wil-btn--block wil-btn--round"
                      style="font-weight: bold; color: red">
                      Business Closures
                    </h3>
                  </div>
                  <div *ngIf="listing.business_hour == 'always_open'" class="content-box_body__3tSRB">
                    <h3 class="alway-open wil-btn wil-btn--block wil-btn--secondary wil-btn--round">Open 24/7</h3>
                  </div>
                  <div *ngIf="listing.business_hour == 'open_for_selected_hours'" data-toggle-content="hour"
                    class="listing-hours_body__3StC3 active" style="display: block">
                    <ul class="listing-hours_listhours__270Nz list-none">
                      <li *ngFor="let item of listing_hours; let i = index"
                        [ngClass]="current_weekday == i ? (isTodayOpen ? 'open' : 'close') : ''"
                        class="listing-hours_item__1B8Vv">
                        <span class="listing-hours_day__2Opo_">{{ item.day_of_week }}</span>
                        <div class="listing-hours_hour__1OuD9">
                          <span *ngIf="item.is_open != 1; else openToday" class="listing-hours_houritem__3cCSp">Day
                            Off</span>
                          <ng-template #openToday>
                            <span class="listing-hours_houritem__3cCSp">{{ item.first_hour_start }} - {{
                              item.first_hour_end }}</span>
                            <span *ngIf="item.second_hour_start && item.second_hour_end"
                              class="listing-hours_houritem__3cCSp">{{ item.second_hour_start }} - {{
                              item.second_hour_end }}</span>
                          </ng-template>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- listing contact info -->
                <div *ngIf="listing_contact" class="wilcity-sidebar-item-business-info content-box_module__333d9">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h4 class="content-box_title__1gBHS">
                        <i class="la la-map-signs"></i><span>Business Info</span>
                      </h4>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB">
                    <div *ngIf="listing_contact.email"
                      class="icon-box-1_module__uyg5F one-text-ellipsis mt-20 mt-sm-15 wil-listing-email">
                      <div class="icon-box-1_block1__bJ25J">
                        <a href="mailto:{{ listing_contact.email }}">
                          <div class="icon-box-1_icon__3V5c0 rounded-circle"><i class="la la-envelope"></i></div>
                          <div class="icon-box-1_text__3R39g">{{ listing_contact.email }}</div>
                        </a>
                      </div>
                    </div>
                    <div *ngIf="listing_contact.phone"
                      class="icon-box-1_module__uyg5F one-text-ellipsis mt-20 mt-sm-15 wil-listing-phone">
                      <div class="icon-box-1_block1__bJ25J">
                        <a href="tel:{{ listing_contact.phone }}">
                          <div class="icon-box-1_icon__3V5c0 rounded-circle"><i class="la la-phone"></i></div>
                          <div class="icon-box-1_text__3R39g">{{ listing_contact.phone }}</div>
                        </a>
                      </div>
                    </div>
                    <div *ngIf="listing_contact.website"
                      class="icon-box-1_module__uyg5F one-text-ellipsis mt-20 mt-sm-15 wil-listing-website">
                      <div class="icon-box-1_block1__bJ25J">
                        <a target="_blank" href="{{ listing_contact.website }}" rel="nofollow">
                          <div class="icon-box-1_icon__3V5c0 rounded-circle"><i class="la la-globe"></i></div>
                          <div class="icon-box-1_text__3R39g">{{ listing_contact.website }}</div>
                        </a>
                      </div>
                    </div>
                    <div class="icon-box-1_module__uyg5F one-text-ellipsis mt-20 mt-sm-15 text-pre wil-listing-address">
                      <div class="icon-box-1_block1__bJ25J">
                        <a target="_blank" href="https://www.google.com/maps/search/{{ listing.address | encodeURL }}">
                          <div class="icon-box-1_icon__3V5c0 rounded-circle"><i class="la la-map-marker"></i></div>
                          <div class="icon-box-1_text__3R39g">{{ listing.address }}</div>
                        </a>
                      </div>
                    </div>

                    <ul *ngIf="hasSocialLinks" class="social-links">
                      <li *ngIf="socialLinks.instagram">
                        <a href="{{ socialLinks.instagram }}" target="_blank">
                          <img src="/assets/social/instagram.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.facebook">
                        <a href="{{ socialLinks.facebook }}" target="_blank">
                          <img src="/assets/social/facebook.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.twitter">
                        <a href="{{ socialLinks.twitter }}" target="_blank">
                          <img src="/assets/social/twitter.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.linkedin">
                        <a href="{{ socialLinks.linkedin }}" target="_blank">
                          <img src="/assets/social/linkedin.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.tiktok">
                        <a href="{{ socialLinks.tiktok }}" target="_blank">
                          <img src="/assets/social/tiktok.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.pinterest">
                        <a href="{{ socialLinks.pinterest }}" target="_blank">
                          <img src="/assets/social/pinterest.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.youtube">
                        <a href="{{ socialLinks.youtube }}" target="_blank">
                          <img src="/assets/social/youtube.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.spotify">
                        <a href="{{ socialLinks.spotify }}" target="_blank">
                          <img src="/assets/social/spotify.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.apple_music">
                        <a href="{{ socialLinks.apple_music }}" target="_blank">
                          <img src="/assets/social/apple_music.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.tidal">
                        <a href="{{ socialLinks.tidal }}" target="_blank">
                          <img src="/assets/social/tidal.png" class="social-icon">
                        </a>
                      </li>

                      <li *ngIf="socialLinks.soundcloud">
                        <a href="{{ socialLinks.soundcloud }}" target="_blank">
                          <img src="/assets/social/soundcloud.png" class="social-icon">
                        </a>
                      </li>
                    </ul>

                    <a (click)="openContactOwnerModal()" class="
                        wilcity-inbox-btn
                        wil-btn wil-btn--block
                        mt-20
                        wil-btn--border wil-btn--round
                        wil-listing-inbox
                      ">
                      <i class="la la-envelope color-1"></i> <span class="">Send a Message</span>
                    </a>
                  </div>
                </div>

                <!-- listing price -->
                <div *ngIf="listing.price_min || listing.price_max"
                  class="wilcity-sidebar-item-price-range content-box_module__333d9">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h4 class="content-box_title__1gBHS">
                        <i class="la la-envelope-square"></i><span>Price Range</span>
                      </h4>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB wilcity-price-range-nottosay">
                    <div class="price-range_module__348HY clearfix">
                      <div class="price-range_sign__3thLa"><i class="fas fa-pound-sign"></i></div>
                      <div class="price-range_group__23kMb">
                        <div class="price-range_range__19Fut color-primary">
                          <div class="price-range_from__3iV-6">£{{ listing.price_min | decimalPipe }}</div>
                          <div class="price-range_arrow__3LnNe"><i class="la la-arrow-right"></i></div>
                          <div class="price-range_to__2Tf3W">£{{ listing.price_max | decimalPipe }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- listing categories -->
                <div class="content-box_module__333d9 wilcity-sidebar-item-term-box wilcity-sidebar-item-listing_cat">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h4 class="content-box_title__1gBHS"><i class="la la-sitemap"></i><span>Categories</span></h4>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB">
                    <div class="row row-listing-categories d-flex">
                      <div *ngFor="let item of listing_categories" class="single-listing-category">
                        <div class="icon-box-1_module__uyg5F two-text-ellipsis mb-20 mb-sm-15">
                          <div class="icon-box-1_block1__bJ25J">
                            <a href="{{ siteUrl }}/listing/search/?listing_cat={{ item.listing_categories_id }}"
                              title="{{ item.title }}">
                              <div class="bg-transparent icon-box-1_icon__3V5c0 rounded-circle">
                                <img src="{{ item.image | imageSrc: 'listing' }}" alt="{{ item.title }}" />
                              </div>
                              <div class="icon-box-1_text__3R39g">{{ item.title }}</div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- listing statistics -->
                <div class="wilcity-sidebar-item-statistic content-box_module__333d9">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h4 class="content-box_title__1gBHS"><i class="la la-bar-chart"></i><span>Statistic</span></h4>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB">
                    <div class="row">
                      <div class="col-sm-6 col-sm-6-clear">
                        <div class="icon-box-1_module__uyg5F two-text-ellipsis mt-20 mt-sm-15">
                          <div class="icon-box-1_block1__bJ25J">
                            <div class="icon-box-1_icon__3V5c0 rounded-circle"><i class="la la-eye"></i></div>
                            <div class="icon-box-1_text__3R39g">
                              {{ listing.view }} View{{ listing.view | pluralPipe }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-sm-6-clear">
                        <div class="icon-box-1_module__uyg5F two-text-ellipsis mt-20 mt-sm-15">
                          <div class="icon-box-1_block1__bJ25J">
                            <div class="icon-box-1_icon__3V5c0 rounded-circle"><i class="la la-star-o"></i></div>
                            <div class="icon-box-1_text__3R39g">{{ listing.no_of_rating }} Rating</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-sm-6-clear">
                        <div class="icon-box-1_module__uyg5F two-text-ellipsis mt-20 mt-sm-15">
                          <div class="icon-box-1_block1__bJ25J">
                            <div class="icon-box-1_icon__3V5c0 rounded-circle"><i class="la la-heart-o"></i></div>
                            <div class="icon-box-1_text__3R39g">
                              {{ listing.favorites }} Favorite{{ listing.favorites | pluralPipe }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-sm-6 col-sm-6-clear">
                        <div class="icon-box-1_module__uyg5F two-text-ellipsis mt-20 mt-sm-15">
                          <div class="icon-box-1_block1__bJ25J">
                            <div class="icon-box-1_icon__3V5c0 rounded-circle"><i class="la la-share"></i></div>
                            <div class="icon-box-1_text__3R39g">
                              {{ listing.share }} Share{{ listing.share | pluralPipe }}
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>

                <!-- listing map -->
                <div class="content-box_module__333d9">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h4 class="content-box_title__1gBHS">
                        <i class="la la-map-marker"></i>
                        <span>Map</span>
                      </h4>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB pos-r">
                    <div id="googleMap" style="width: 100%; height: 300px"></div>
                  </div>
                </div>

                <!-- listing claim -->
                <div *ngIf="!listing.claimer_id" class="wilcity-sidebar-item-claim content-box_module__333d9">
                  <header class="content-box_header__xPnGx clearfix">
                    <div class="wil-float-left">
                      <h4 class="content-box_title__1gBHS"><i class="la la-check"></i><span>Claim Listing</span></h4>
                    </div>
                  </header>
                  <div class="content-box_body__3tSRB">
                    <div class="promo-item_module__24ZhT">
                      <div class="promo-item_group__2ZJhC">
                        <h3 class="promo-item_title__3hfHG">Is this your business?</h3>
                        <p class="promo-item_description__2nc26">
                          Claim listing is the best way to manage and protect your business.
                        </p>
                      </div>
                      <div class="promo-item_action__pd8hZ">
                        <a (click)="onClickClaimListing(listing.id)"
                          class="wil-btn wil-btn--dark wil-btn--sm wil-btn--round">
                          <span class="">Claim This Listing</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- current tab = description -->
          <div *ngIf="current_tab == 'description'" class="single-tab-content">
            <div class="content-box_module__333d9 pos-r">
              <header class="content-box_header__xPnGx clearfix">
                <div class="wil-float-left">
                  <h4 class="content-box_title__1gBHS">
                    <i class="la la-file-text"></i>
                    <span>Description</span>
                  </h4>
                </div>
              </header>
              <div class="content-box_body__3tSRB">
                <div class="full-load" style="height: auto; display: none">
                  <div class="pill-loading_module__3LZ6v pos-a-center">
                    <div class="pill-loading_loader__3LOnT"></div>
                  </div>
                </div>
                <div [innerHTML]="listing.description">

                </div>
              </div>
            </div>
          </div>

          <!-- current tab = photos -->
          <div *ngIf="current_tab == 'photos'" id="single-photos" class="single-tab-content">
            <div class="content-box_module__333d9 pos-r">
              <header class="content-box_header__xPnGx clearfix">
                <div class="wil-float-left">
                  <h4 class="content-box_title__1gBHS"><i class="la la-image"></i> <span>Photos</span></h4>
                </div>
              </header>
              <div class="content-box_body__3tSRB">
                <div *ngIf="listing_galleries.length > 0; else templateNoPhoto" class="">
                  <div data-col-xs-gap="5" data-col-sm-gap="10" class="row">
                    <div *ngFor="let item of listing_galleries; let index = index" class="col-xs-6 col-sm-3">
                      <div class="gallery-item_module__1wn6T">
                        <div class="imageCover_module__1VM4k">
                          <div class="imageCover_img__3pxw7" (click)="openGalleryModal(index)"
                            [ngStyle]="{ 'background-image': 'url(' + item.medium + ')' }">
                            <img [src]="item.medium" class="cursor-pointer" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #templateNoPhoto>
                  <div class="alert_module__Q4QZx" style="padding-left: 15px">
                    <div class="alert_content__1ntU3">There are no photos</div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <!-- current tab = videos -->
          <div *ngIf="current_tab == 'videos'" id="single-nav-videos" class="single-tab-content">
            <div class="content-box_module__333d9 pos-r">
              <header class="content-box_header__xPnGx clearfix">
                <div class="wil-float-left">
                  <h4 class="content-box_title__1gBHS">
                    <i class="la la-video-camera"></i>
                    <span>Videos</span>
                  </h4>
                </div>
              </header>
              <div class="content-box_body__3tSRB">
                <div class="gallery_module__2AbLA">
                  <div *ngIf="listing_videos.length > 0; else templateNoVideo">
                    <div data-col-xs-gap="5" data-col-sm-gap="10" class="row">
                      <div *ngFor="let item of listing_videos; let index = index" class="col-xs-12 col-sm-4">
                        <div class="gallery-item_module__1wn6T">
                          <div class="video-popup_module__2P6ZG video-popup_sm__11-9c">
                            <div class="video-popup_media__dEwwq">
                              <div class="video-popup_img__3zV5d bg-cover"
                                [ngStyle]="{ 'background-image': 'url(' + item.image + ')' }"></div>
                              <a (click)="openVideoModal(index)" class="video-popup_popup__17b-F js-video-popup"><i
                                  class="la la-play"></i></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #templateNoVideo>
                    <div class="alert_module__Q4QZx" style="padding-left: 15px">
                      <div class="alert_content__1ntU3">There are no videos</div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <!-- current tab = reviews -->
          <div *ngIf="current_tab == 'reviews'" id="single-nav-reviews" class="single-tab-content">
            <div class="content-box_module__333d9 pos-r">
              <header class="content-box_header__xPnGx clearfix">
                <div class="wil-float-left">
                  <h4 class="content-box_title__1gBHS">
                    <i class="la la-star-o"></i>
                    <span>Reviews</span>
                  </h4>
                </div>
              </header>
              <div class="listing-detail_row__2UU6R">
                <div class="wil-colLarge js-sticky pos-r">
                  <div class="pos-r wil-reviews-tab">
                    <div *ngIf="listing_reviews.length > 0" data-v-0af02974="" id="" class="pos-r">
                      <div data-v-0af02974="">
                        <div *ngFor="let item of listing_reviews; let index = index"
                          class="comment-review_module__-Z5tr" data-v-0af02974="">
                          <div class="comment-review_header__1si3M">
                            <div class="
                                utility-box-1_module__MYXpX
                                utility-box-1_boxLeft__3iS6b
                                clearfix
                                utility-box-1_sm__mopok
                                review-author-avatar
                              ">
                              <a class="utility-box-1_avatar__DB9c_ rounded-circle"
                                [ngStyle]="{ 'background-image': 'url(' + getReviewAvatar(item.profile_photo) + ')' }">
                                <img src="{{ item.profile_photo | imageSrc: 'users':'thumb' }}"
                                  alt="{{ item.display_name != '' ? item.display_name : item.username }}" /></a>
                              <div class="utility-box-1_body__8qd9j">
                                <div class="utility-box-1_group__2ZPA2">
                                  <h3 class="utility-box-1_title__1I925">
                                    <a>{{ item.display_name != '' ? item.display_name : item.username }}</a>
                                  </h3>
                                </div>
                                <div class="utility-box-1_description__2VDJ6">
                                  {{ item.created_at | date: 'longDate' }}
                                </div>
                              </div>
                            </div>
                            <div class="comment-review_abs__9mb1G pos-a-center-right">
                              <span class="comment-review_sticky__3iQ8y color-primary fs-20 v-middle visible-hidden"><i
                                  class="la la-thumb-tack"></i></span>
                              <div class="rated-small_module__1vw2B">
                                <div [attr.data-rated]="item.rating" class="rated-small_wrap__2Eetz">
                                  <div class="rated-small_overallRating__oFmKR">{{ item.rating }}</div>
                                  <div class="rated-small_ratingWrap__3lzhB">
                                    <div class="rated-small_maxRating__2D9mI">10</div>
                                    <div class="rated-small_ratingOverview__2kCI_">
                                      {{ review_comment[item.rating] }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="userCanEditReview(item.id)"
                                (clickOutside)="isReviewDotsClicked[item.id] = false"
                                class="dropdown_module__J_Zpj ml-20">
                                <div
                                  (click)="isReviewDotsClicked[item.id] = isReviewDotsClicked[item.id] ? false : true"
                                  class="dropdown_threeDots__3fa2o">
                                  <span class="dropdown_dot__3I1Rn"></span> <span class="dropdown_dot__3I1Rn"></span>
                                  <span class="dropdown_dot__3I1Rn"></span>
                                </div>
                                <div [ngClass]="{ active: isReviewDotsClicked[item.id] }"
                                  class="dropdown_itemsWrap__2fuze">
                                  <ul data-v-52d0a98f="" class="
                                      list_module__1eis9
                                      list-none
                                      list_small__3fRoS
                                      list_abs__OP7Og
                                      arrow--top-right
                                    " has-wrap-for-icon="true">
                                    <li class="list_item__3YghP">
                                      <a data-v-52d0a98f="" (click)="openReviewModal(item)"
                                        class="list_link__2rDA1 text-ellipsis color-primary--hover"
                                        span-classes="list_text__35R07" review-id="17458">
                                        <span class="list_icon__2YpTp"><i class="la la-edit"></i></span>
                                        <span class="list_text__35R07">Edit review</span>
                                      </a>
                                    </li>
                                    <li class="list_item__3YghP">
                                      <a data-v-52d0a98f="" (click)="onDeleteReview(item.id)"
                                        class="list_link__2rDA1 text-ellipsis color-primary--hover"
                                        span-classes="list_text__35R07" review-id="17458">
                                        <span class="list_icon__2YpTp"><i class="la la-trash"></i></span>
                                        <span class="list_text__35R07">Delete</span>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="comment-review_body__qhUqq">
                            <div class="comment-review_content__1jFfZ">
                              <h3 class="comment-review_title__2WbAh">{{ item.title }}</h3>
                              <div class="wilcity-review-content wilcity-review-content-17458">
                                <div>
                                  <p>{{ item.description }}</p>
                                </div>
                              </div>
                            </div>
                            <div class="comment-review_meta__1chzm">
                              <span>{{ item.likes }} Like{{ item.likes | pluralPipe: 's' }}</span>
                              <span>{{ item.comments }} Comment{{ item.comments | pluralPipe: 's' }}</span>
                            </div>
                          </div>
                          <footer data-v-52d0a98f="" class="comment-review_footer__3XR0_">
                            <div data-v-52d0a98f="" class="comment-review_btnGroup__1PqPh">
                              <div data-v-52d0a98f="" class="comment-review_btn__32CMP">
                                <a (click)="onClickLikeReview(item.id, index)" class="utility-meta_module__mfOnV"
                                  [ngClass]="{ 'color-primary': userHasLikedReview(item) }" btn-classes="'no-style'"
                                  socials="facebook,twitter,linkedin,whatsapp">
                                  <i class="la la-thumbs-up"></i>
                                  <span class="">Like</span>
                                </a>
                              </div>
                            </div>
                            <div style="min-height: 100px" data-v-52d0a98f="">
                              <div>
                                <ul *ngIf="item.comment_list.length > 0"
                                  class="comment-review_commentlist__1LH_D list-none">
                                  <li *ngFor="let comment of item.comment_list"
                                    class="comment-review_commentlistItem__2DILM js-review-discussion-17459">
                                    <div data-v-7b959e52="" class="">
                                      <div class="
                                          utility-box-1_module__MYXpX
                                          utility-box-1_xs__3Nipt
                                          utility-box-1_boxLeft__3iS6b
                                          clearfix
                                        ">
                                        <a data-v-7b959e52="" [ngStyle]="{
                                            'background-image': 'url(' + getReviewAvatar(comment.profile_photo) + ')'
                                          }" class="utility-box-1_avatar__DB9c_ rounded-circle wil-float-left">
                                          <img src="{{ comment.profile_photo | imageSrc: 'users':'thumb' }}"
                                            alt="" /></a>
                                        <div data-v-7b959e52="" class="utility-box-1_body__8qd9j">
                                          <div data-v-7b959e52="" class="utility-box-1_group__2ZPA2">
                                            <h3 data-v-7b959e52="" class="utility-box-1_title__1I925">
                                              <a data-v-7b959e52="">{{
                                                comment.display_name != '' ? comment.display_name : comment.username
                                                }}</a>
                                            </h3>
                                            <div data-v-7b959e52="" class="utility-box-1_content__3jEL7">
                                              {{ comment.description }}
                                            </div>
                                          </div>
                                          <div data-v-7b959e52="" class="utility-box-1_description__2VDJ6"></div>
                                        </div>
                                        <div *ngIf="isCommentEditClicked[comment.id]"
                                          class="comment-review_comment__dJNqv mt-10">
                                          <div class="active field_module__1H6kT field_style4__2DBqx field-autoHeight">
                                            <div class="field_wrap__Gv92k">
                                              <textarea #commentField
                                                (keyup)="onKeydownCommentField($event, item.id, comment.id)"
                                                data-height-default="22"
                                                class="field_field__3U_Rt">{{ comment.description }}</textarea>
                                              <span class="field_label__2eCP7 text-ellipsis">Type a message...</span>
                                              <span class="bg-color-primary"></span>
                                              <div class="field_rightButton__1GGWz js-field-rightButton active">
                                                <span (click)="onSubmitComment(item.id, commentField.value, comment.id)"
                                                  class="field_iconButton__2p3sr bg-color-primary"><i
                                                    class="la la-arrow-up"></i></span>
                                              </div>
                                              <div class="mt-10 pos-a review-cancel">
                                                <a (click)="onCloseCommentEdit(comment.id)" title="Cancel"><i
                                                    class="la la-times-circle"></i></a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div *ngIf="userCanEditComment(comment)"
                                        (clickOutside)="isCommentDotsClicked[comment.id] = false"
                                        class="dropdown_module__J_Zpj">
                                        <div (click)="
                                            isCommentDotsClicked[comment.id] = isCommentDotsClicked[comment.id]
                                              ? false
                                              : true
                                          " class="dropdown_threeDots__3fa2o">
                                          <span class="dropdown_dot__3I1Rn"></span>
                                          <span class="dropdown_dot__3I1Rn"></span>
                                          <span class="dropdown_dot__3I1Rn"></span>
                                        </div>
                                        <div [ngClass]="{ active: isCommentDotsClicked[comment.id] }"
                                          class="dropdown_itemsWrap__2fuze">
                                          <ul data-v-7b959e52="" class="
                                              list_module__1eis9
                                              list-none
                                              list_small__3fRoS
                                              list_abs__OP7Og
                                              arrow--top-right
                                            " has-wrap-for-icon="true">
                                            <li class="list_item__3YghP">
                                              <a (click)="onClickCommentEdit(comment.id)"
                                                class="list_link__2rDA1 text-ellipsis color-primary--hover">
                                                <span class="list_icon__2YpTp"><i class="la la-edit"></i></span>
                                                <span class="list_text__35R07">Edit</span>
                                              </a>
                                            </li>
                                            <li class="list_item__3YghP">
                                              <a (click)="onDeleteComment(comment.id)"
                                                class="list_link__2rDA1 text-ellipsis color-primary--hover">
                                                <span class="list_icon__2YpTp"><i class="la la-trash"></i></span>
                                                <span class="list_text__35R07">Delete</span>
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                                <div class="comment-review_form__20wWm">
                                  <div class="
                                      utility-box-1_module__MYXpX
                                      utility-box-1_xs__3Nipt
                                      d-inline-block
                                      mr-10
                                      wil-float-left
                                    ">
                                    <a class="utility-box-1_avatar__DB9c_ rounded-circle"
                                      [ngStyle]="{ 'background-image': 'url(' + assetUrl + '/img/avatar-default.png)' }"><img
                                        src="{{ assetUrl + '/img/avatar-default.png' }}" alt="" /></a>
                                  </div>
                                  <div class="comment-review_comment__dJNqv">
                                    <div class="field_module__1H6kT field_style4__2DBqx field-autoHeight-2">
                                      <div class="field_wrap__Gv92k">
                                        <textarea #commentField (keyup)="onKeydownCommentField($event, item.id)"
                                          data-height-default="22" class="field_field__3U_Rt"></textarea>
                                        <span class="field_label__2eCP7 text-ellipsis">Type a message...</span>
                                        <span class="bg-color-primary"></span>
                                        <div class="field_rightButton__1GGWz js-field-rightButton">
                                          <span (click)="onSubmitComment(item.id, commentField.value)"
                                            class="field_iconButton__2p3sr bg-color-primary"><i
                                              class="la la-arrow-up"></i></span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </footer>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wil-colSmall js-sticky">
                  <div>
                    <div class="content-box_module__333d9">
                      <header class="content-box_header__xPnGx clearfix">
                        <div class="wil-float-left">
                          <h4 class="content-box_title__1gBHS">
                            <i class="la la-star-o"></i>
                            <span><span class="color-primary">{{ listing.avg_rating }} average for </span>
                              <span> {{ listing.title }}</span></span>
                          </h4>
                        </div>
                      </header>
                      <div class="content-box_body__3tSRB">
                        <div class="rated-info-group_module__20kAf">
                          <div class="rated-info-group_body__2yvB5">
                            <div class="rated-info_module__KsMQP">
                              <div class="rated-info_title__2Oido">How Would You Rate This Business?</div>
                              <div class="rated-info_wrap__AI5nf">
                                <div class="rated-info_progressBar__1pCWE">
                                  <div class="rated-info_bar__1T7U7"
                                    [ngStyle]="{ left: listing.avg_rating * 10 + '%' }"></div>
                                </div>
                              </div>
                              <div class="rated-info_overallRating__1Js4A">{{ listing.avg_rating }}</div>
                            </div>
                          </div>
                          <div class="rated-info-group_footer__2mcef">
                            <h3>Average Rating</h3>
                            <div class="rated-small_module__1vw2B rated-info-group_rated__29vEF pos-a-center-right">
                              <div [attr.data-rated]="listing.avg_rating" class="rated-small_wrap__2Eetz">
                                <div class="rated-small_overallRating__oFmKR">{{ listing.avg_rating }}</div>
                                <div class="rated-small_ratingWrap__3lzhB">
                                  <div class="rated-small_maxRating__2D9mI">10</div>
                                  <div class="rated-small_ratingOverview__2kCI_">
                                    {{ fnReviewComment(listing.avg_rating) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <a *ngIf="currentUserCanReview; else tmpUserCanEditReview" (click)="openReviewModal()"
                      class="wil-btn wil-btn--primary wil-btn--round wil-btn--md wil-btn--block">
                      <span class="">Add review</span>
                    </a>
                    <ng-template #tmpUserCanEditReview>
                      <a (click)="openReviewModal(currentUserReview)"
                        class="wil-btn wil-btn--primary wil-btn--round wil-btn--md wil-btn--block">
                        <span class="">Edit review</span>
                      </a>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- current tab = my shop -->
          <div *ngIf="current_tab == 'products'" id="single-nav-products" class="single-tab-content">
            <div class="content-box_module__333d9 pos-r">
              <header class="content-box_header__xPnGx clearfix">
                <div class="wil-float-left">
                  <h4 class="content-box_title__1gBHS"><i class="la la-shopping-cart"></i> <span>My Shop</span></h4>
                </div>
              </header>
              <div class="content-box_body__3tSRB">
                <div *ngIf="listing_products && listing_products.length > 0; else templateNoProduct"
                  class="products-container">
                  <div class="product-preview" *ngFor="let product of listing_products">
                    <app-product-preview [product]="product"></app-product-preview>
                  </div>
                </div>
                <ng-template #templateNoProduct>
                  <div class="alert_module__Q4QZx" style="padding-left: 15px">
                    <div class="alert_content__1ntU3">There are no products</div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-group-fixed_module__3qULF pos-f-right-bottom text-right">
      <a *ngIf="showEditButton" id="wil-edit-listing-btn" href="{{ siteUrl + '/listing/edit/' + listing_slug }}"
        class="wil-btn wil-btn--secondary wil-btn--round wil-btn--md wil-edit-listing-btn"><i
          class="la la-edit"></i>Edit Listing
      </a>
      <div class="mb-10"></div>
      <button *ngIf="showSubmitButton" (click)="onSubmitListing()" id="wilcity-submit"
        class="wil-btn wil-btn--primary2 wil-btn--round wil-btn--md wil-submit-listing-btn">
        <i class="la la-send"></i>Submit Listing
        <div class="pill-loading_module__3LZ6v hidden">
          <div class="pill-loading_loader__3LOnT"></div>
        </div>
      </button>
    </div>
  </div>
</div>